export const FETCH_SAFESCARF_PRODUCTS_STARTED = 'FETCH_SAFESCARF_PRODUCTS_STARTED' as const;
export const FETCH_SAFESCARF_PRODUCTS_FULFILLED = 'FETCH_SAFESCARF_PRODUCTS_FULFILLED' as const;
export const UPDATE_SAFESCARF_PRODUCT_STARTED = 'UPDATE_SAFESCARF_PRODUCT_STARTED' as const;
export const UPDATE_SAFESCARF_PRODUCT_FULFILLED = 'UPDATE_SAFESCARF_PRODUCT_FULFILLED' as const;
export const CREATE_SAFESCARF_PRODUCT_STARTED = 'CREATE_SAFESCARF_PRODUCT_STARTED' as const;
export const CREATE_SAFESCARF_PRODUCT_FULFILLED = 'CREATE_SAFESCARF_PRODUCT_FULFILLED' as const;
export const DELETE_SAFESCARF_PRODUCT_STARTED = 'DELETE_SAFESCARF_PRODUCT_STARTED' as const;
export const DELETE_SAFESCARF_PRODUCT_FULFILLED = 'DELETE_SAFESCARF_PRODUCT_FULFILLED' as const;

export const fetchProducts = (productId?: unknown) => ({
  type: FETCH_SAFESCARF_PRODUCTS_STARTED,
  payload: productId,
});

export const fetchProductsFulfilled = (data: unknown) => ({
  type: FETCH_SAFESCARF_PRODUCTS_FULFILLED,
  payload: data,
});

export const updateProduct = (data: unknown) => ({ type: UPDATE_SAFESCARF_PRODUCT_STARTED, payload: data });

export const updateProductFulfilled = (data: unknown) => ({
  type: UPDATE_SAFESCARF_PRODUCT_FULFILLED,
  payload: data,
});

export const createProduct = (data: unknown) => ({ type: CREATE_SAFESCARF_PRODUCT_STARTED, payload: data });

export const createProductFulfilled = (data: unknown) => ({
  type: CREATE_SAFESCARF_PRODUCT_FULFILLED,
  payload: data,
});

export const deleteProduct = (id: string) => ({ type: DELETE_SAFESCARF_PRODUCT_STARTED, payload: id });

export const deleteProductFulfilled = (id: string) => ({
  type: DELETE_SAFESCARF_PRODUCT_FULFILLED,
  payload: id,
});
